import { render, staticRenderFns } from "./CodeBrunchCalculator.vue?vue&type=template&id=861e63f8&"
import script from "./CodeBrunchCalculator.vue?vue&type=script&lang=ts&"
export * from "./CodeBrunchCalculator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports